export enum LegalClientActivity {
  /** Национальное или региональное правительство */
  NationalOrRegionalGovernment = 'NationalOrRegionalGovernment',
  /** Госорган, управляющий государственным долгом */
  GovernmentDebtManagementAgency = 'GovernmentDebtManagementAgency',
  /** Центральный банк */
  CentralBank = 'CentralBank',
  /** Международная или наднациональная организация (например, Всемирный банк, Международный Валютный Фонд или Европейский Инвестиционный Банк) */
  InternationalOrSupranationalOrganization = 'InternationalOrSupranationalOrganization',
  /** Уполномоченное или регулируемое финансовое учреждение, включая банки, страховые компании */
  AuthorizedOrRegulatedFinancialInstitution = 'AuthorizedOrRegulatedFinancialInstitution',
  /** Регулируемая торговая площадка, депозитарий или клиринговая организация */
  RegulatedMarketDepositoryOrClearingHouse = 'RegulatedMarketDepositoryOrClearingHouse',
  /** Уполномоченное/регулируемое предприятие коллективного инвестирования или его управляющая компания */
  RegulatedCollectiveInvestmentUndertaking = 'RegulatedCollectiveInvestmentUndertaking',
  /** Пенсионный фонд или его управляющая компания */
  PensionFundOrManagementCompany = 'PensionFundOrManagementCompany',
  /** Товарно-сырьевой дилер или дилер товарно-сырьевых деривативов */
  CommodityOrCommodityDerivativesDealer = 'CommodityOrCommodityDerivativesDealer',
  /** Компания, чьи акции допущены к торгам на бирже страны-члена МОКЦБ */
  PublicCompanyListedOnStockExchange = 'PublicCompanyListedOnStockExchange',
  /** Доверительный управляющий траста, имеющий активы на сумму не менее 10 миллионов USD */
  TrustManagerWithAssetsOver10M = 'TrustManagerWithAssetsOver10M',
  /** Прочий институциональный инвестор, инвестирующий в финансовые инструменты */
  OtherInstitutionalInvestorInFinancialInstruments = 'OtherInstitutionalInvestorInFinancialInstruments',
  /** Другое */
  Other = 'Other',
}

export interface LegalClientActivityEntity {
  activity: LegalClientActivity;
  isLargeEnterprise: boolean;
  isNominalHolder: boolean;
  requiresNominalHoldingSubaccount?: boolean;
  otherActivity?: string;
}
